// Copyright (c) 2016 Deere & Company

import JdpClaimContainer from '../../claim/marketing/jdp/state-connector';

export default {
    component: JdpClaimContainer,
    name: 'MARKETING_JD_PROMISE',
    path: 'jdp/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/jdp-claim-route.js